import moment from "moment";
import { getCurrentLanguage } from "./config";
import momentTimezone from "moment-timezone";

export const getTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const convertHoursToDays = (numberOfHours: number): number => {
  const days = Math.floor(numberOfHours / 24);
  return days;
};

export const isToday = (date: any): boolean => {
  return moment(date).isSame(moment(), "day");
};

export const isSameDay = (date1: any, date2: any): boolean => {
  const year = moment().format("YYYY");
  const yearDate1 = moment(date1).format("YYYY");
  let processedDate1 = date1;
  if (year !== yearDate1) {
    processedDate1 = `${year}-${date1}`;
  }
  const momentDate1 = moment(moment(processedDate1).format("MM/DD/YYYY"));
  const momentDate2 = moment(moment(date2).format("MM/DD/YYYY"));
  return momentDate1.diff(momentDate2, "days") === 0;
};

export const getDayFormat = (date: any, prefix?: string): string => {
  const momentDate = moment(date);
  const dateFormatted = momentDate.locale(getCurrentLanguage()).format("LL");
  if (isToday(momentDate)) {
    return "Aujourd'hui";
  }
  return prefix
    ? `${prefix} ${dateFormatted}`
    : dateFormatted;
};


export const formatPromotionDate = (dateString: string): string => {
  return moment(dateString).locale("fr").format("LL");
};

export const getDateFormat = (date: any): string => {
  return moment(date).locale(getCurrentLanguage()).format("LLL");
};

export const formatEstimationTime = (estimationTime: any) => {
  let estimationTimeFormat = "";
  let estimationDayFormat = "";
  let estimationTimeFormatWithMargin = "";

  if (estimationTime) {
    const isToday = estimationTime.isSame(moment(), "day");
    estimationTimeFormat = `${estimationTime
      .format("HH:mm")
      .replace(":", "h")}`;

    estimationTimeFormatWithMargin = isToday
      ? `entre ${estimationTimeFormat} - ${estimationTime
        .clone()
        .add(20, "minutes")
        .format("HH:mm")
        .replace(":", "h")}`
      : estimationTimeFormat;

    estimationDayFormat = isToday
      ? "Aujourd'hui"
      : estimationTime.clone().locale("fr").format("LL");
  }

  return {
    estimationTimeFormat,
    estimationDayFormat,
    estimationTimeFormatWithMargin,
  };
};

export const minutesToTime = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

export const timeToMinutes = (time: string): number => {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

export const getDateToday = (date?: string | Date, timezone?: string) => {
  const formatDay = "dddd";
  let day: string | moment.Moment = moment(date);

  if (timezone) {
    day = momentTimezone(day).tz(timezone).format(formatDay);
  }

  return day;
};
export const getTimeHM = (date: any): string => {
  if (!date) return "";

  return moment(date).format("HH:mm");
};
